import type { RoleAssignmentResponse } from '../types';
import { initials } from '../lib/formatters';
import styles from './RolesPanel.module.css';

export type RolesPanelProps = {
  roundNumber: number | null;
  assignments: RoleAssignmentResponse[];
  youPlayerId?: string | null;
  youPlayerName?: string | null;
};

function isYou(
  a: RoleAssignmentResponse,
  youPlayerId?: string | null,
  youPlayerName?: string | null,
): boolean {
  if (youPlayerId && a.playerId === youPlayerId) return true;
  if (youPlayerName && a.playerName.toLowerCase() === youPlayerName.toLowerCase()) return true;
  return false;
}

export default function RolesPanel({
  roundNumber,
  assignments,
  youPlayerId,
  youPlayerName,
}: RolesPanelProps) {
  const meta =
    roundNumber != null
      ? `R${roundNumber} · ${assignments.length} assigned`
      : `${assignments.length} assigned`;

  return (
    <section className={styles.panel} aria-labelledby="live-roles-heading">
      <div className={styles.head}>
        <h2 id="live-roles-heading">Roles</h2>
        <span className={styles.meta}>{meta}</span>
      </div>
      {assignments.length === 0 ? (
        <p className={styles.empty}>No roles assigned yet.</p>
      ) : (
        <ul className={styles.list}>
          {assignments.map((a) => {
            const you = isYou(a, youPlayerId, youPlayerName);
            return (
              <li key={`${a.playerId}-${a.strategyRoleId}`} className={`${styles.row} ${you ? styles.rowYou : ''}`}>
                <div className={styles.av} aria-hidden="true">
                  {initials(a.playerName)}
                </div>
                <div className={styles.player}>
                  {a.playerName}
                  {you && <span className={styles.youMark}> · YOU</span>}
                </div>
                <span className={styles.badge}>{a.roleName}</span>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
